<style scoped>
.abs-col {
  /* position: absolute; */
  /* top: 0px;
    /*bottom: 0;*/
  overflow-y: auto;
  padding: 0 !important;
  background-color: white;
  height: 100vh;
}

.abs-col:last-child {
  z-index: 1;
  box-shadow: 2px 3px 6px 0px black;
}

.abs-col:first-child {
  padding-bottom: 64px;
}

ul.collapsible {
  margin: 0;
  border: 0;
}

.main-content-nopad {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 64px;
  overflow: hidden;
}
</style>
<style>
.search-box .v-text-field__slot input {
  margin-bottom: 0;
}
</style>
<template lang="pug">
.main-content-nopad
  .row.no-margin
    .abs-col.col.l3.m4.s12.px0
      ul.collapsible(ref='collapsibleOrders')
        //- ul
        ul
          li.pt-5
            v-text-field#search.px-2.search-box(
              label='Reference Number',
              placeholder='Search order',
              v-model='searchReferenceNumber'
            )
        app-filtered-order-list(
          :orders='orders',
          :status='"new"',
          @viewOrder='viewOrder',
          :searching='searching',
          :activeIndexId='activeIndexId',
          :filterBy='searchReferenceNumber'
        )
        app-filtered-order-list(
          :orders='orders',
          :status='"processing"',
          @viewOrder='viewOrder',
          :searching='searching',
          :activeIndexId='activeIndexId',
          :filterBy='searchReferenceNumber'
        )
        app-filtered-order-list(
          :orders='orders',
          :status='"in-transit"',
          @viewOrder='viewOrder',
          :searching='searching',
          :activeIndexId='activeIndexId',
          :filterBy='searchReferenceNumber'
        )
    .abs-col.col.l9.m8
      app-order-details(
        :order='selectedOrder',
        isAbsolute,
        :isErr='filterERR',
        @orderUpdated='onOrderUpdated'
      )

  vue-modal.hide-on-med-and-up(
    v-if='selectedOrder',
    :class='{ hide: !viewReferenceNumber }',
    :options='{ fullscreen: true, padding: "none" }',
    @close='modalClose'
  )
    component(
      :is='modalContent',
      v-bind='{ order: selectedOrder, isAbsolute: true }',
      @orderUpdated='onOrderUpdated'
    )
</template>
<script>
import AppFilteredOrderList from './app-filtered-order-list'
import AppOrderDetails from './app-order-details'
import VueModal from 'vue-modal'

export default {
  meta: {
    title: 'Orders'
  },
  data () {
    return {
      orders: null,
      viewReferenceNumber: null,
      searchListener: null,
      selectedOrder: null,
      filterERR: null,
      modalContent: AppOrderDetails,
      interval: null,
      searchReferenceNumber: null,
      searching: false,
      activeIndexId: null
    }
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  watch: {
    supplier () {
      this.initializeOrders()
    },
    '$route.params' () {
      this.initializeOrders()
    }
  },
  created () {
    this.initializeOrders()
    this.interval = setInterval(() => {
      this.initializeOrders()
    }, 30000)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  mounted () {
    this.$M.Collapsible.init(this.$refs.collapsibleOrders)
    // this.viewReferenceNumber = this.$route.query.referenceNumber
    // this.searchListener = debounce(this.searchOrder, 1000)
    const search = document.getElementById('search')
    search.addEventListener('keyup', this.searchListener)
  },
  methods: {
    initializeOrders () {
      this.getOrders()
      this.viewReferenceNumber = this.$route.params.referenceNumber
      if (this.viewReferenceNumber) {
        this.getOrderByReference(this.viewReferenceNumber)
      }
    },
    getOrderByReference (referenceNumber) {
      if (!this.supplier) {
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/orders/${referenceNumber}`,
            {
              params: {
                deep: true
              },
              headers: {
                Authorization: 'Bearer ' + accessToken
              }
            }
          )
          .then((result) => {
            this.selectedOrder = result.data
            this.filterERR = false
          })
          .catch(() => {
            // what now?
            this.filterERR = true
          })
      })
    },
    getOrders () {
      if (!this.supplier) {
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(`${this.$config.API_URL}/suppliers/${this.supplier.id}/orders`, {
            params: {
              deep: false,
              confirmationStatus: 'confirmed'
            },
            headers: {
              Authorization: 'Bearer ' + accessToken
            }
          })
          .then((result) => {
            this.orders = result.data
            // TODO Parse orders to orderItem
          })
      })
    },
    searchOrder () {
      this.searching = true
      this.$router.push({
        name: 'orderByReference',
        params: { referenceNumber: this.searchReferenceNumber }
      })
    },
    viewOrder (order) {
      this.activeIndexId = order.id
      this.searching = false
      if (this.$route.params.referenceNumber !== order.referenceNumber) {
        this.$router.push({
          name: 'orderByReference',
          params: { referenceNumber: order.referenceNumber }
        })
      }
    },
    onOrderUpdated (order) {
      this.getOrderByReference(order.referenceNumber)
      this.getOrders()
    },
    modalClose () {
      this.selectedOrder = null
      this.$router.back()
    }
  },
  components: {
    AppFilteredOrderList,
    AppOrderDetails,
    VueModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-order-items.vue